<template>
    <div class="overflow-hidden cursor-pointer" @click="clickCampaign()">
        <div class="campaign-image rounded-10" :style="{'background-image': `url('${campaign.fullImageUrl}')`}"></div>
        <div class="p-4 flex justify-between">
            <div>
                <div class="text-16 text-a-brown-502314">
                    <div class="text-1-line">{{campaign.name}}</div>
                </div>
                <div v-if="campaign.extraJson != null" class="flex mt-4">
                    <img v-for="(img, k) in campaign.extraJson.detail" :key="k" :src="img.image_url" class="w-8 mr-4">
                </div>
            </div>
            <div class="flex-shrink-0 flex flex-col items-end">
                <div class="text-16 text-a-red-d62300">{{FilterNumberFormat(campaign.pricePerUnit)}} {{lbl.main.bath}}</div>
                <div class="mt-2">
                    <div class="bg-a-red-d62300 text-16 text-a-egg-f5ebdc rounded-full px-3 py-1">
                        {{lbl.main.select}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "CampaignItem",
    mixins: [LocaleMixin],
    props: {
        campaign: { type: Object, required: true },
    },
    methods: {
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && this.localeCode == 1033 ? 's' : '');
            return pointType + " " + this.campaign.pointPerUnit + " " + pointUnit;
        },

        clickCampaign: function() {
            this.tracking.event('homepage','click_menu', `click_${this.campaign.id} | ${this.campaign.name}`, null);
            this.$router.push('/product/' + this.campaign.id);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        @include boxRatio($ratio: 66.66%);
    }
</style>
